export default {"src":"/_next/static/media/player-sillouette.aca3afc3.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};